/*
 * @Author: huangshimin@klcxkj.com
 * @Date: 2022-03-28 14:36:42
 * @LastEditors: klcxkjhsm huangshimin@klcxkj.com
 * @LastEditTime: 2025-12-30 19:48:31
 * @FilePath: \app-client-h5\src\App.js
 */
import React, { Component } from 'react'
import { BrowserRouter as Router, Route, } from 'react-router-dom'
import Home from './pages/home';
import My from './pages/my';
import BindTel from './pages/bindTel';
import BindRoom from './pages/bindRoom';
import RechargeWater from './pages/rechargeWater';
import RechargeResult from './pages/rechargeResult';
import OrderDetail from './pages/orderDetail';
import OrderList from './pages/orderList';
import WaterUseRecord from './pages/waterUseRecord';
import TestToAds from './pages/testToAds';
import Transfer from './pages/transfer';
import CardBinding from './pages/cardBinding'
import CardRechargeInfo from './pages/cardRechargeInfo';
import SuccessPage from './pages/successPage';
import WalletSuccessPage from './pages/walletSuccessPage';
import BillDetail from './pages/billDetail';
import BindingStudent from './pages/bindingStudent';
import RechargeComplete from './pages/rechargeComplete';
import MiniProgramPage from './pages/miniProgramPage';
import TicketPage from './pages/ticketPage';
import OnlineService from './pages/onlineService';
import BillDetailAdmin from './pages/billDetailAdmin';
import Coupon from './pages/coupon';
import CouponRegister from './pages/couponRegister';
import RechangeSuccess from './pages/rechangeSuccess';
import CardPasswordFreePay from './pages/cardPasswordFreePay'
import CloseCardPasswordFreePay from './pages/closeCardPassWordFreePay'
// import CardAuthentication from './pages/cardAuthentication'
import AuthenticateSuccess from './pages/authenticateSuccess'
import AuthenticateMessage from './pages/authenticateMessage'
import AuthenticateBinding from './pages/authenticateBinding'
import AuthenticateBindingSuccess from './pages/authenticateBindingSuccess'
import AuthenticateJump from './pages/authenticateJump';
import CardSelfBillDetail from './pages/cardSelfBillDetail'
import QuzhiCampus from './pages/quzhiCampus'
import AuthenticateJumpTip from './pages/authenticateJumpTip'
import AdvPromotion from './pages/advPromotion'
import Authorization from './pages/authorization'
import BindingCardKaiHe from './pages/bindingCardKaiHe'
import RechargeCardKaiHe from './pages/rechargeCardKaiHe';
import HelpCenter from './pages/helpCenter';
import BeginnerGuide from './pages/beginnerGuide';
import YsfTipPage from './pages/ysfTipPage';

export default class App extends Component {
  render() {
    return (
      <Router>
        <Route path="/testToAds" component={TestToAds} />
        <Route path="/transfer" component={Transfer} />
        <Route path="/bindTel" component={BindTel} />
        <Route path="/bindRoom" component={BindRoom} />
        <Route path="/rechargeWater" component={RechargeWater} />
        <Route path="/rechargeResult" component={RechargeResult} />
        <Route path="/orderDetail" component={OrderDetail} />
        <Route path="/orderList" component={OrderList} />
        <Route path="/home" component={Home} />
        <Route path="/waterUseRecord" component={WaterUseRecord} />
        <Route path="/my" component={My} />
        {/* 卡片自助机h5账单详情cardSelfBillDetail */}
        <Route path="/cardSelfBillDetail" component={CardSelfBillDetail} />
        {/* 正元一卡通充值页面 */}
        <Route path="/cardBinding" component={CardBinding} />
        <Route path="/cardRechargeInfo" component={CardRechargeInfo} />
        <Route path="/successPage" component={SuccessPage} />
        {/* 充值成功回钱包（与 successPage 隔离，供系统浏览器唤回 App） */}
        <Route path="/walletSuccessPage" component={WalletSuccessPage} />
        {/* 正元一卡通充值页面 */}
        {/* <Route path="/" exact component={Transfer} /> */}
        {/* 账单详情 */}
        <Route path="/billDetail" component={BillDetail} />
        {/* 账单详情管理端 */}
        <Route path="/billDetailAdmin" component={BillDetailAdmin} />
        <Route path="/bindingStudent" component={BindingStudent} />
        <Route path="/rechargeComplete" component={RechargeComplete} />
        <Route path="/miniProgramPage" component={MiniProgramPage} />
        <Route path="/ticketPage" component={TicketPage} />
        {/* 一卡通授权页面 */}
        <Route path="/authorization" component={Authorization} /> 
        {/*支付宝在线客服H5 */}
        <Route path="/onlineService" component={OnlineService} />
        {/*用户端优惠券分享 */}
        <Route path="/coupon" component={Coupon} />
        <Route path="/couponRegister" component={CouponRegister} />
        {/**单独充值 */}
        <Route path="/rechangeSuccess" component={RechangeSuccess} />
        {/* 一卡通免密支付 */}
        <Route path="/cardPasswordFreePay" component={CardPasswordFreePay} />
        {/* 关闭一卡通免密支付 */}
        <Route path="/closeCardPasswordFreePay" component={CloseCardPasswordFreePay} />
        {/* 一卡通认证 */}
        {/* <Route path="/cardAuthentication" component={CardAuthentication} /> */}
        {/* 一卡通重新认证 */}
        <Route path="/authenticateSuccess" component={AuthenticateSuccess} />
        {/* 一卡通认证成功 */}
        <Route path="/authenticateMessage" component={AuthenticateMessage} />
        <Route path="/authenticateBinding" component={AuthenticateBinding} />
        <Route path="/authenticateBindingSuccess" component={AuthenticateBindingSuccess} />
        {/* 一卡通认证跳转 */}
        <Route path="/authenticateJump" component={AuthenticateJump} />
        {/*跳转小程序*/}
        <Route path="/quzhiCampus" component={QuzhiCampus} />
        {/*川信一卡通h5*/}
        <Route path="/authenticateJumpTip" component={AuthenticateJumpTip} />
        {/* 广告推广 */}
        <Route path="/advPromotion" component={AdvPromotion} />
        {/* 凯和一卡通绑定充值页面 */}
        <Route path="/bindingCardKaiHe" component={BindingCardKaiHe} />
        <Route path="/rechargeCardKaiHe" component={RechargeCardKaiHe} />
        {/* 用户端-帮助说明 */}
        <Route path="/helpCenter" component={HelpCenter} />   {/* 帮助中心 */}
        <Route path="/beginnerGuide" component={BeginnerGuide} />   {/* 新手指南 */}
        {/* 云闪付易校园提示页 */}
        <Route path="/ysfTipPage" component={YsfTipPage} />
      </Router>
    )
  }
}